module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/media/movie-lane-2-b1a72fd006ad1f24d4903a1426306b72.svg";